import { Editor } from 'grapesjs';
import { LevelV2Renderer } from '@loyalty/editor-components';
import { faSortAmountUp } from '@fortawesome/pro-solid-svg-icons/faSortAmountUp';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import { LevelV2WidgetTraits } from './LevelV2WidgetTraits';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';
import { setInnerHTML } from '../utils/set-inner-html';

const CLASSNAME = 'qlf-level';

export const levelV2ComponentDefinition: EditorComponentDefinition = {
  id: 'level-v2',
  icon: faSortAmountUp,
  category: 'Gamification',
  getLabel: ({ t }) => t('editor.component.level'),
  traits: {
    form: LevelV2WidgetTraits,
  },
  component: LevelComponent,
};

function LevelComponent(editor: Editor) {
  const i18n = editor.I18n;
  const context: EditorContext = editor.Config.context;

  editor.DomComponents.addType(levelV2ComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains(CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        droppable: false,
        draggable: '[data-gjs-type=column]',
        attributes: {
          mustacheVars: ['level'],
          showProgressBar: true,
          showLevelName: true,
          showExpiration: false,
          showAmountUntilNextLevel: true,
          progressFormat: 'direct',
        },
        traits: [],
      },
      initToolbar: Toolbar,
      init() {
        this.on('change:attributes', this.refresh);
      },
      refresh() {
        setTimeout(() => this.view?.onRender());
      },
      toHTML(): string {
        return LevelV2Renderer(
          {
            state: context.widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        setInnerHTML(el, model.toHTML());
      },
    },
  });
}
